import styled from "styled-components";

export const BillingDataContainerModal = styled.div`
  width: 100%;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.404);
  // background-color: transparent;
  position: fixed;
  top: -0px;
  z-index: 99999;
  display: flex;
  align-items: center;
`;
export const BillingDataContainerModalContent = styled.div`
  max-width: 1000px;
  height: 80%;
  box-shadow: 2px 2px 15px 2px rgba(228, 228, 228, 0.493);
  background-color: #ffffff;
  position: relative;
  margin-left: auto;
  margin-right: auto;
  align-self: center;
  border: 30px solid white;
`;
export const BillingDataContainerModalContentFilter = styled.div`
  position: relative;
  margin-left: auto;
  margin-right: auto;
  display: flex;
  justify-content: center;
  margin-top: 20px;
  color: #ff7e00;

  .margin-top {
    top: 10px;
  }
  .product {
    height: 80px;
    position: relative;
    margin-left: auto;
    margin-right: auto;
    display: flex;
    justify-content: center;
    margin-top: 20px;
    color: #ff7e00;
  }
  .parceiro {
    position: relative;
    margin-left: auto;
    margin-right: auto;
    display: flex;
    justify-content: center;
    margin-top: 5px;
    color: #ff7e00;
  }
`;
export const BillingDataContainerModalContentFilterSelect = styled.div`
  background-color: #fff;
  -webkit-border-radius: 3px;
  -moz-border-radius: 3px;
  border-radius: 3px;
  padding: 0 5px;
  font-size: 16px;
  font-family: "Akrobat ExtraBold";
  letter-spacing: 0.03rem;
  margin: 0 10px;
  display: flex;
  align-items: center;
  input {
    height: 32px;
    border: 1px solid #919aae;
    color: #919aae;
    margin-left: 3px;
    border-radius: 3px;
    outline: none;
  }
`;
// export const BillingDataContainerModalContentFilterSelectLabel = styled.div`
//   background-color: #fff;
//   -webkit-border-radius: 3px;
//   -moz-border-radius: 3px;
//   border-radius: 3px;
//   padding: 0 5px;
//   font-size: 16px;
//   font-family: "Akrobat ExtraBold";
//   letter-spacing: 0.03rem;
//   margin: 0 10px;
//   display: flex;
//   align-items: center;
//   input {
//     height: 32px;
//     border: 1px solid #919aae;
//     color: #919aae;
//     margin-left: 3px;
//     border-radius: 3px;
//     outline: none;
//   }
// `;

export const BillingDataContainerModalContentFilterButton = styled.button`
  background-color: #ff7e00;
  color: #fff;
  border: none;
  padding: 0 13px;
  height: 38px;
  margin-left: 10px;

  .white {
    background-color: rgb(233, 231, 231);
    color: rgb(78, 78, 78);
    border: none;
    padding: 0 13px;
    height: 38px;
    margin-left: 10px;
  }
`;
export const BillingDataContainerModalContentFilterButtonWhite = styled(
  BillingDataContainerModalContentFilterButton
)`
  background-color: rgb(233, 231, 231);
  color: rgb(78, 78, 78);
`;
export const BillingDataContainerModalContentGrid = styled.div`
  // width: 95%;
  height: 90%;
  position: relative;
  margin-left: auto;
  margin-right: auto;
  // overflow-x: scroll;
  overflow-y: auto;
  // background-color: rgb(248, 248, 248);
  // border: 15px solid white;
`;
export const BillingDataContainerModalContentGridLoading = styled.div`
  width: 100%;
  height: 100%;
  position: absolute;
  background-color: #ffffff;
  align-items: center;
  z-index: 9999;
`;
export const BillingDataContainerModalContentGridLoadingContent = styled.div`
  width: 100px;
  height: 100%;
  position: relative;
  margin-left: auto;
  margin-right: auto;
  display: flex;
  align-items: center;
  img {
    width: 100px;
    height: 100px;
    position: relative;
    margin-left: auto;
    margin-right: auto;
  }
`;
export const BillingDataContainerModalContentGridColumn = styled.div`
  margin-top: 20px;
  font-size: 14px;
  color: #919aae;
  font-weight: 300;
  position: relative;
  .border {
    width: 100px;
    border: 1px #ff7e00 solid;
    border-radius: 5px;
    width: 110px;
    margin-right: 5px;
  }

  thead {
    // width: 700px;
    // border-bottom: 2px solid #ff7e00;
    tr {
      th {
        min-width: 80px;
        color: #ff7e00;
        font-family: "Akrobat ExtraBold";
        font-size: 15px;

        .checkbox-size {
          width: 40px;
          min-width: 40px;
          max-width: 40px;
        }
        .title-rotate {
          transform: rotate(-90deg);
          min-width: 40px;
          max-width: 40px;
        }
        &:nth-child(1) {
          width: 30px;
        }
      }

      &:nth-child(1) {
        width: 30px;
      }
    }
  }

  tbody {
    width: 700px;
    tr {
      margin: 10px 0;

      &:nth-child(even) {
        background-color: #fcfdfc;
      }

      &:nth-child(1) {
        width: 30px;
      }

      td {
        min-width: 80px;
        text-transform: uppercase;
        text-align: center;
        font-family: "Akrobat";
        font-size: 15px;
        padding: 0 10px;
        height: 50px;

        &:nth-child(1) {
          width: 30px;
        }

        .checkbox-size {
          width: 40px;
          position: relative;
          top: -10px;
          min-width: 40px;
          max-width: 40px;
        }

        .cub {
          display: flex;
          align-items: center;

          text-transform: inherit;

          a {
            text-decoration: none;
            display: flex;
            color: #ff7e00;
          }

          .icon {
            margin-right: 5px;
          }
        }

        .btn {
          padding: 0;
        }
      }
    }
  }
`;
